import { userApi, mockDataApi, } from '@/api';
import QueryParameterBuilder from '@/lib/query-parameter/QueryParameterBuilder';
import PaginationOutput from '@/helpers/PaginationOutput';
import { field, embed, } from '@/lib/query-parameter/resource';
import * as filterOption from '@/lib/query-parameter/filter';
import { injectSortParamHelper } from '@/lib/query-parameter/sortby';
const { injectFilterParamHelper, equals, } = filterOption;
export default {
    async getUserInfo() {
        const params = new QueryParameterBuilder()
            .addFields(field('userId', 'name', 'telephone'))
            .build();
        const response = await userApi.getUserMe(params);
        return response.data;
    },
    async getMockDataUserList() {
        const response = await mockDataApi.getMockDataUserList();
        return PaginationOutput.adaptorFactory(response);
    },
    async isUserIdExist(payload) {
        const response = await userApi.postUserIdExistence(payload);
        return response.data;
    },
    // 사용자 관리 - 조회/등록/수정
    async getUserList({ pageNumber, pageSize, filters, sortOption, hubId, }) {
        const params = new QueryParameterBuilder()
            .addFilters(equals('hubId', hubId))
            .addPageNumber(pageNumber)
            .addPageSize(pageSize);
        injectFilterParamHelper(params, filters);
        injectSortParamHelper(params, sortOption);
        const response = await userApi.getUserList(params.build());
        return PaginationOutput.adaptorFactory(response);
    },
    async getUser(userId) {
        const params = new QueryParameterBuilder()
            .addEmbeds(embed('hub'));
        const response = await userApi.getUser(userId, params.build());
        return response.data;
    },
    async postUser(data) {
        const response = await userApi.postUser(data);
        return response.data;
    },
    async putUser(userId, data = {}) {
        const response = await userApi.putUser(userId, data);
        return response.data;
    },
    async getUserPermissionList(userId) {
        const response = await userApi.getUserMenuAuthority(userId);
        return response.data;
    },
    async putUserPermissionList(userId, data) {
        const response = await userApi.putUserMenuAuthority(userId, data);
        return response.data;
    },
};
